import colors from 'vuetify/es5/util/colors'
var themes = {
  light: {
    primary: '#1f337d',
    secondary: '#F4F4F5',
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  },
  dark: {
    primary: colors.blue.darken2,
    secondary: colors.grey.lighten2,
    accent: colors.blue.accent1,
    error: colors.red.accent2,
    info: colors.blue,
    success: colors.green,
    warning: colors.amber
  }
}

export default {
  dark: false,
  options: {
    customProperties: true
  },
  logo: 'assets/imgs/logo.svg',
  background: 'assets/imgs/background.svg',
  themes: themes
}
